import { proformApiQuery } from '@eliadmin/core/src/api/proform/proform-api';
import { useQuery } from '@tanstack/react-query';

export function useProductConfVariants(cislo_nomenklatury: string) {
  return useQuery({
    queryKey: ['GET_PRODUCT_CONF_KOD_PROV', { cislo_nomenklatury }],
    queryFn: async () => {
      return proformApiQuery('GET_PRODUCT_CONF_KOD_PROV', {
        cislo_nomenklatury: cislo_nomenklatury,
        id_shop: 3,
      }).then(res => {
        if (Array.isArray(res.root.smako_conf_kod_prov?.kod_prov)) {
          return res.root.smako_conf_kod_prov?.kod_prov;
        }

        return [res.root.smako_conf_kod_prov?.kod_prov];
      });
    },
    enabled: Boolean(cislo_nomenklatury),
    retry: false,
    throwOnError: false,
  });
}
